var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiposBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_84f2d9c36c6f682a106822db86590265",
    "data-name": "84f2d9c36c6f682a106822db86590265",
    transform: "translate(-10 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_557",
    "data-name": "Caminho 557",
    d: "M34.266,38h-5.6a3.734,3.734,0,0,1-3.734-3.734v-5.6a3.734,3.734,0,0,1,3.734-3.734h5.6A3.734,3.734,0,0,1,38,28.666v5.6A3.734,3.734,0,0,1,34.266,38Zm1.869-11.2H26.8v9.334h9.334Zm-1.869-3.734h-5.6a3.734,3.734,0,0,1-3.734-3.734v-5.6A3.737,3.737,0,0,1,28.666,10h5.6A3.734,3.734,0,0,1,38,13.734v5.6A3.733,3.733,0,0,1,34.266,23.066Zm1.869-11.2H26.8V21.2h9.334ZM19.334,38h-5.6A3.734,3.734,0,0,1,10,34.266v-5.6a3.734,3.734,0,0,1,3.734-3.734h5.6a3.734,3.734,0,0,1,3.734,3.734v5.6A3.737,3.737,0,0,1,19.334,38ZM21.2,26.8H11.866v9.334H21.2Zm-1.866-3.734h-5.6A3.733,3.733,0,0,1,10,19.334v-5.6A3.734,3.734,0,0,1,13.734,10h5.6a3.734,3.734,0,0,1,3.734,3.734v5.6A3.737,3.737,0,0,1,19.334,23.066Z",
    transform: "translate(0 0)",
    fill: "#009ebe"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiposBlue);
export default __webpack_public_path__ + "static/media/tiposBlue.c779eba0295698c3c8f614d1defc5f32.svg";
export { ForwardRef as ReactComponent };